<template>
    <v-container fluid>
        <div v-if="!loading">
            <v-row>
                <v-col>
                    <h4 class="text-h4">{{$t('Brand')}}: <span v-if="data" class="font-weight-bold">{{data.name}}</span></h4>
                    <p class="text-subtitle-1">{{$t('brand_information')}}</p>
                    <v-divider></v-divider>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="3" v-if="hasPermission(permissions.brand.update)">
                    <v-btn depressed block @click="handleEdit">
                        <v-icon left>mdi-pencil</v-icon>
                        {{$t('edit')}}
                    </v-btn>
                </v-col>
                <v-col cols="12" md="3" v-if="hasPermission(permissions.brand.delete)">
                    <v-btn :loading="deleteLoading" depressed color="error--text" block @click="handleDelete">
                        <v-icon left>mdi-delete</v-icon>
                        {{$t('delete')}}
                    </v-btn>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <v-simple-table dense>
                        <tbody>
                            <tr>
                                <th>{{$t('name')}}</th>
                                <td>{{ data ? data.name : null }}</td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-col>
            </v-row>
        </div>
        <div v-else>
            <v-row>
                <v-col>
                    <v-skeleton-loader type="heading" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-divider/>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="d-flex flex-row">
                    <v-skeleton-loader type="button" class="my-2 mx-2"/>
                    <v-skeleton-loader type="button" class="my-2 mx-2"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                </v-col>
            </v-row>
        </div>
         <v-row v-if="!loading">
                <v-col>
                    <h5 class="text-h5">{{$t('models')}}</h5>
                    <ModelList v-if="models" :models="models" :brand="data"/>
                </v-col>
            </v-row>
        <PAlert v-model="alert.model" v-bind="alert"/>
    </v-container>        
</template>

<script>
import brandAPI from './../../../services/fleet/brand'
import PAlert from './../../../components/common/PAlert.vue';
import ModelList from '@/components/fleet/ModelList'
import permissions from '../../../data/permissions';
import authorize from '../../../utils/authorize';
export default {
    components: {
        PAlert,
        ModelList
    },
    data() {
        return {
            data: null,
            brandID: null,
            loading: false,
            deleteLoading: false,
            alert: {
                title: "Alert",
                content: "",
                callback: null,
                model: false
            },
            models: null,
            permissions
        }
    },
    methods: {
        hasPermission(code) {
            return authorize(code)
        },
        async fetchBrandAsync() {
            this.loading = true;
            var [ brandResp, modelsResp] = await Promise.all([
                brandAPI.get(this.brandID),
                brandAPI.listModels(this.brandID)
            ])
            this.data = brandResp.data
            this.models = modelsResp.data
            this.loading = false
        },
        handleEdit() {
            this.$router.push({ name: "BrandEdit"})
        },
        handleDelete() {
            this.alert = {...this.alert, model: true, content: "Are you sure you want to delete?", callback: this.delete}
        },
        delete() {
            this.deleteLoading = true
            brandAPI.remove(this.brandID).then(() => {
                 this.$router.push({ name: "BrandList"})
            })
            .finally(() => {
                this.deleteLoading = false
            })
        }
    },
    created() {
        this.brandID = this.$route.params.brandID;
        this.fetchBrandAsync();
    }
}
</script>

<style>

</style>